/**
 * Project panel
 *
 * Created by stefensuhat on 11/06/18 4.44 PM
 */
import { Checkbox, makeStyles, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import DeleteCircle from '@material-ui/icons/DeleteOutlineRounded';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Number } from '../../../components';

const styles = makeStyles(({ palette }) => ({
    deleted: {
        background: palette.primary.light,
    },
}));

function tableCell(value, number = false, money = false) {
    return (
        <TableCell padding="dense">
            {number ? <Number prefix={money} value={value} /> : value}
        </TableCell>
    );
}

function SelectedItems({
    items, deletedMenu, onSubscriptionOrRecommendedClicked, onDeleteClick, onMealTypeChange,
}) {
    const classes = styles();

    return (
        <>
            <Typography gutterBottom variant="h6">
                Selected Menu
            </Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        {tableCell('')}
                        {tableCell('Name')}
                        {tableCell('Price')}
                        {tableCell('Subscription')}
                        {tableCell('Lunch')}
                        {tableCell('Dinner')}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.length < 1
                    && (
                        <TableRow>
                            <TableCell colSpan={7}>
                                <Typography align="center" variant="body1">
                                    - NO MENU SELECTED -
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )}
                    {items.map((item) => {
                        if (item.delete) {
                            return <Fragment key={item.id} />;
                        }

                        const itemIsDeleted = deletedMenu.includes(item.id);

                        return (
                            <TableRow hover={!itemIsDeleted} key={item.id} className={itemIsDeleted && classes.deleted}>
                                <TableCell padding="checkbox">
                                    {itemIsDeleted
                                        ? (
                                            <Button variant="outlined" onClick={() => onDeleteClick(item, 'cancel')}>
                                                Cancel
                                            </Button>
                                        )
                                        : (
                                            <Button variant="outlined" onClick={() => onDeleteClick(item, 'delete')}>
                                                <DeleteCircle />
                                                {' '}
                                                Delete
                                            </Button>
                                        )
                                    }

                                </TableCell>
                                {tableCell(item.name)}
                                {tableCell(item.selling_price, true, true)}
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        checked={item.subscription}
                                        onChange={() => onSubscriptionOrRecommendedClicked(item, 'subscription')}
                                    />
                                </TableCell>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        checked={item.meals.includes('lunch')}
                                        onChange={() => onMealTypeChange(item, 'lunch')}
                                    />
                                </TableCell>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        checked={item.meals.includes('dinner')}
                                        onChange={() => onMealTypeChange(item, 'dinner')}
                                    />
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </>
    );
}


SelectedItems.propTypes = {
    deletedMenu: PropTypes.array,
    items: PropTypes.array,
    onSubscriptionOrRecommendedClicked: PropTypes.func.isRequired,
    onMealTypeChange: PropTypes.func.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
};
SelectedItems.defaultProps = { deletedMenu: [], items: [] };

export default SelectedItems;
